let copyTimeout;
document.addEventListener('click', function(e) {
    if (e.target.closest('.copyLink')) {
        e.preventDefault();
        
        if (copyTimeout) return;
        
        const copyBtn = e.target.closest('.copyLink');
        const link = copyBtn.getAttribute('href');
        
        navigator.clipboard.writeText(link);
        
        copyBtn.classList.add('onCopy');
        copyTimeout = setTimeout(() => {
            copyBtn.classList.remove('onCopy');
            copyTimeout = null;
        }, 1500);
    }
});